(function () {
  'use strict';

  var STORAGE_KEY = 'cap_quote_stage_status_v2';
  var TOKEN_KEY = 'cap_quote_stage_token_v1';
  var STATUS_TTL_MS = 30 * 60 * 1000;
  var MANAGER_STATUS_TTL_MS = 24 * 60 * 60 * 1000;
  var STATUS_POLL_INTERVAL_MS = 10 * 1000;
  var SLOW_STATUS_NOTICE_MS = 120 * 1000;
  var TERMINAL_TIMEOUT_MS = 5 * 60 * 1000;
  var statusEl = null;
  var observer = null;
  var lastAction = '';
  var rendering = false;
  var state = null;
  var realtimeClient = null;
  var realtimeChannel = null;
  var slowNoticeTimer = 0;
  var terminalTimer = 0;
  var statusPollTimer = 0;
  var statusPollInFlight = false;
  var quoteLoaderEl = null;
  var retryInFlight = false;
  var managerCheckInFlight = false;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeUrl(value) {
    try {
      var raw = String(value || '').trim();
      if (!raw) return '';
      var parsed = new URL(raw, window.location.origin);
      return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }


  function safeMondayUrl(value) {
    var url = safeUrl(value);
    if (!url) return '';
    try {
      var parsed = new URL(url);
      var validHost = parsed.hostname === 'callahan-auto-parts.monday.com';
      var validPath = /^\/boards\/9726565776\/views\/252022714\/pulses\/\d+$/.test(parsed.pathname);
      return validHost && validPath ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function safePodiumUrl(value) {
    var url = safeUrl(value);
    if (!url) return '';
    try {
      var parsed = new URL(url);
      var validHost = parsed.hostname === 'app.podium.com';
      var validPath = parsed.pathname === '/inbox';
      var validLocation = parsed.searchParams.get('locationUid') === 'a5b3915d-2f61-5327-b5dc-68118267706a';
      var validConversation = /^conversationUid_[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(parsed.searchParams.get('_sid') || '');
      return validHost && validPath && validLocation && validConversation ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function isToken(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(String(value || '').trim().toLowerCase());
  }


  function getQuoteLoader() {
    if (quoteLoaderEl && document.body.contains(quoteLoaderEl)) return quoteLoaderEl;
    if (!document.body) return null;
    quoteLoaderEl = document.createElement('div');
    quoteLoaderEl.id = 'cap-quote-loader';
    quoteLoaderEl.className = 'callahan-loader callahan-loader--overlay';
    quoteLoaderEl.hidden = true;
    quoteLoaderEl.setAttribute('role', 'status');
    quoteLoaderEl.setAttribute('aria-live', 'polite');
    quoteLoaderEl.setAttribute('aria-label', 'Creating quote');
    quoteLoaderEl.innerHTML =
      '<div class="callahan-loader__tile" aria-hidden="true">' +
        '<div class="callahan-loader__bars"><i></i><i></i><i></i></div>' +
        '<div class="callahan-loader__mark"><img alt="" decoding="async"></div>' +
      '</div>' +
      '<div class="callahan-loader__text">Creating your quote</div>';
    document.body.appendChild(quoteLoaderEl);
    return quoteLoaderEl;
  }

  function setQuoteLoaderLogo(loader) {
    if (!loader) return;
    var image = loader.querySelector('.callahan-loader__mark img');
    if (!image || image.getAttribute('src')) return;
    var source = document.querySelector('.header__heading-logo, header img[src], img[src*="logo"]');
    var src = source ? (source.currentSrc || source.getAttribute('src') || '') : '';
    if (src) image.src = src;
  }

  function showQuoteLoader() {
    var loader = getQuoteLoader();
    if (!loader) return;
    setQuoteLoaderLogo(loader);
    loader.hidden = false;
  }

  function hideQuoteLoader() {
    if (quoteLoaderEl) quoteLoaderEl.hidden = true;
  }

  function saveState() {
    if (!state) return;
    try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (error) {}
  }

  function disconnectRealtime() {
    if (realtimeClient && realtimeChannel) {
      try { realtimeClient.removeChannel(realtimeChannel); } catch (error) {}
    }
    realtimeChannel = null;
    realtimeClient = null;
  }

  function clearDeadlineTimers() {
    window.clearTimeout(slowNoticeTimer);
    slowNoticeTimer = 0;
    window.clearTimeout(terminalTimer);
    terminalTimer = 0;
  }

  function stopStatusTracking() {
    clearDeadlineTimers();
    window.clearTimeout(statusPollTimer);
    statusPollTimer = 0;
    statusPollInFlight = false;
    disconnectRealtime();
  }

  function clearState() {
    retryInFlight = false;
    managerCheckInFlight = false;
    hideQuoteLoader();
    stopStatusTracking();
    state = null;
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
      window.sessionStorage.removeItem(TOKEN_KEY);
    } catch (error) {}
  }

  function loadState() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || !isToken(saved.token)) return null;
      var ttl = isManagerApprovalPendingState(saved) ? MANAGER_STATUS_TTL_MS : STATUS_TTL_MS;
      if (!Number.isFinite(Number(saved.startedAt)) || Date.now() - Number(saved.startedAt) > ttl) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        window.sessionStorage.removeItem(TOKEN_KEY);
        return null;
      }
      ['monday','payment'].forEach(function (key) {
        if (saved.snapshot && saved.snapshot[key] && saved.snapshot[key].state === 'unconfirmed') {
          saved.snapshot[key].state = 'pending';
        }
      });
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
      return saved;
    } catch (error) {
      return null;
    }
  }

  function stageView(kind, stage, mode) {
    var value = String(stage || 'pending').toLowerCase();
    if (kind === 'shopify') {
      if (value === 'success') return { tone:'success', icon:'✓', text:'Quote / Draft Order successfully created' };
      if (value === 'pending') return { tone:'pending', icon:'•', text:'Creating Quote / Draft Order…' };
      return { tone:'error', icon:'!', text:'Shopify could not create the Quote / Draft Order' };
    }
    if (kind === 'monday') {
      if (value === 'success') return { tone:'success', icon:'✓', text:'Lead and all required linkages verified in Monday.com' };
      if (value === 'pending' && mode === 'manager_approval_pending') return { tone:'pending', icon:'•', text:'Awaiting manager approval' };
      if (value === 'pending') return { tone:'pending', icon:'•', text:'Verifying every Monday.com item and linkage…' };
      if (value === 'blocked') return { tone:'error', icon:'!', text:'Monday.com verification was blocked because Shopify failed' };
      return { tone:'error', icon:'!', text:'Monday lead creation or linkage verification failed' };
    }
    if (value === 'success' && mode === 'soft_quote_no_link') {
      return { tone:'success', icon:'✓', text:'Quote message delivery confirmed; payment link intentionally omitted' };
    }
    if (value === 'success') return { tone:'success', icon:'✓', text:'Payment link delivery confirmed by Podium' };
    if (value === 'accepted') return { tone:'success', icon:'✓', text:'Accepted by Podium; delivery is not confirmed. Do not send again.' };
    if (value === 'pending' && mode === 'manager_approval_pending') return { tone:'pending', icon:'•', text:'Payment blocked pending manager approval' };
    if (value === 'pending' && state && state.snapshot && state.snapshot.monday && state.snapshot.monday.state === 'success') return { tone:'pending', icon:'•', text:'Monday.com verified. Waiting for Podium acceptance…' };
    if (value === 'pending') return { tone:'pending', icon:'•', text:'Waiting for verified Monday.com lead before delivery…' };
    if (value === 'blocked') return { tone:'error', icon:'!', text:'Payment is blocked until the quote is fully verified' };
    return { tone:'error', icon:'!', text:value === 'failed' ? 'Podium message delivery failed' : 'Podium status is unavailable. Check Podium before sending again.' };
  }

  function diagnosticsHtml(kind, stage) {
    if (!state || kind !== 'monday' || !['failed','unconfirmed'].includes(String(stage || '').toLowerCase())) return '';
    var diagnostics = Array.isArray(state.diagnostics) ? state.diagnostics.slice(0, 10) : [];
    var executionId = String(state.automationExecutionId || '').trim();
    if (!diagnostics.length && !executionId) return '';
    var html = '<div class="cap-stage-diagnostics">';
    if (executionId) html += '<div class="cap-stage-diagnostics__reference"><span>Automation execution ID</span><strong>' + escapeHtml(executionId) + '</strong></div>';
    if (diagnostics.length) {
      html += '<ol class="cap-stage-diagnostics__list">';
      diagnostics.forEach(function (entry) {
        entry = entry && typeof entry === 'object' ? entry : {};
        var line = Number(entry.line || 0);
        var heading = [line > 0 ? 'Line ' + line : '', String(entry.item || '').trim(), String(entry.code || '').trim()].filter(Boolean).join(' — ');
        html += '<li><strong>' + escapeHtml(heading || 'Verification failure') + '</strong>' +
          '<span>' + escapeHtml(String(entry.message || 'No additional diagnostic was returned.')) + '</span></li>';
      });
      html += '</ol>';
    }
    return html + '</div>';
  }

  function cardActionsHtml(kind, stage) {
    if (!state) return '';
    var html = '';
    var adminUrl = safeUrl(state.adminUrl);
    var invoiceUrl = safeUrl(state.invoiceUrl);
    var mondayUrl = safeMondayUrl(state.mondayUrl);
    var podiumUrl = safePodiumUrl(state.podiumUrl);
    var mondayVerified = String(state.snapshot && state.snapshot.monday && state.snapshot.monday.state || '') === 'success';

    if (kind === 'shopify' && stage === 'success' && mondayVerified && adminUrl) {
      html = '<a class="rep-tools__status-link rep-tools__status-link--primary" href="' + escapeHtml(adminUrl) + '" target="_blank" rel="noopener noreferrer">Open in Admin</a>';
    } else if (kind === 'monday' && stage === 'pending' && isManagerApprovalPending()) {
      html = '<button type="button" class="rep-tools__status-link rep-tools__status-link--primary cap-stage-manager-check" data-cap-check-manager-approval' +
        (managerCheckInFlight ? ' disabled aria-busy="true"' : '') + '>' +
        (managerCheckInFlight ? 'Checking Manager Approval…' : 'Check Manager Approval') + '</button>';
    } else if (kind === 'monday' && stage === 'success' && mondayUrl) {
      var itemCount = Math.max(1, Number(state.mondayItemCount) || 1);
      var countLabel = itemCount > 1 ? ' (1 of ' + itemCount + ')' : '';
      html = '<a class="rep-tools__status-link rep-tools__status-link--primary" href="' + escapeHtml(mondayUrl) + '" target="_blank" rel="noopener noreferrer">Open in Monday' + countLabel + '</a>';
    } else if (kind === 'monday' && ['failed','unconfirmed'].includes(String(stage || '')) && state.retryAvailable && !retryInFlight) {
      html = '<button type="button" class="rep-tools__status-link rep-tools__status-link--primary cap-stage-retry" data-cap-retry-quote>Retry Monday Verification</button>';
    } else if (kind === 'payment' && mondayVerified && invoiceUrl) {
      html =
        (podiumUrl ? '<a class="rep-tools__status-link rep-tools__status-link--primary" href="' + escapeHtml(podiumUrl) + '" target="_blank" rel="noopener noreferrer">See in Podium</a>' : '') +
        '<a class="rep-tools__status-link rep-tools__status-link--secondary" href="' + escapeHtml(invoiceUrl) + '" target="_blank" rel="noopener noreferrer">Open Payment Link</a>' +
        '<button type="button" class="rep-tools__status-link rep-tools__status-copy" data-rep-copy-payment-link="' + escapeHtml(invoiceUrl) + '" aria-label="Copy payment link">Copy Payment Link</button>';
    }

    return html ? '<div class="cap-stage-card__actions">' + html + '</div>' : '';
  }

  function cardHtml(kind, title, stage, mode) {
    var view = stageView(kind, stage, mode);
    var extra = '';
    var mondayVerified = state && String(state.snapshot && state.snapshot.monday && state.snapshot.monday.state || '') === 'success';
    if (kind === 'shopify' && state && state.draftNumber && stage === 'success' && mondayVerified) {
      extra = '<div class="cap-stage-card__draft-label">Draft Order #</div>' +
        '<div class="cap-stage-card__draft-number">' + escapeHtml(state.draftNumber) + '</div>';
    } else if (kind === 'shopify' && stage === 'success' && !mondayVerified) {
      extra = '<div class="cap-stage-card__draft-label">Draft number hidden until Monday.com verification passes</div>';
    }
    if (kind === 'shopify' && view.tone === 'error') {
      extra += '<div class="cap-stage-card__instruction">Contact Automation Team.</div>';
    }
    if (kind === 'monday' && view.tone === 'error' && stage !== 'blocked') {
      extra += '<div class="cap-stage-card__instruction cap-stage-card__instruction--urgent"><strong>DO NOT CONTINUE.</strong><span>CONTACT AUTOMATION TEAM ASAP.</span></div>' +
        diagnosticsHtml(kind, stage);
    }
    if (kind === 'payment' && stage === 'failed' && mondayVerified) {
      extra += '<div class="cap-stage-card__instruction">Send the payment link manually using the buttons below.</div>';
    }
    return '<section class="cap-stage-card cap-stage-card--' + view.tone + '" data-cap-stage="' + kind + '">' +
      '<div class="cap-stage-card__source">' + escapeHtml(title) + '</div>' +
      '<div class="cap-stage-card__state"><span class="cap-stage-card__icon" aria-hidden="true">' + view.icon + '</span>' +
      '<span>' + escapeHtml(view.text) + '</span></div>' + extra + cardActionsHtml(kind, stage) + '</section>';
  }

  function render(alertText) {
    if (!statusEl || !state || !state.draftId) return;
    var snapshot = state.snapshot || {};
    var shopify = snapshot.shopify ? snapshot.shopify.state : 'success';
    var monday = snapshot.monday ? snapshot.monday.state : 'pending';
    var payment = snapshot.payment ? snapshot.payment.state : 'pending';
    var mode = snapshot.payment ? snapshot.payment.mode : '';
    var mondayMode = snapshot.monday && snapshot.monday.mode ? snapshot.monday.mode : mode;
    var alert = alertText ? '<div class="cap-stage-alert">' + escapeHtml(alertText) + '</div>' : '';

    rendering = true;
    statusEl.classList.add('cap-quote-stage-status-shell');
    statusEl.innerHTML = alert +
      '<div class="cap-quote-stage-grid" role="status" aria-live="polite">' +
      cardHtml('shopify', 'Shopify', shopify, mode) +
      cardHtml('monday', 'Monday.com', monday, mondayMode) +
      cardHtml('payment', 'Podium', payment, mode) +
      '</div>';
    window.setTimeout(function () { rendering = false; }, 0);
  }

  function allTerminal() {
    if (!state || !state.snapshot) return false;
    return ['monday','payment'].every(function (key) {
      return String(state.snapshot[key] && state.snapshot[key].state || 'pending') !== 'pending';
    });
  }

  function isManagerApprovalPendingState(candidate) {
    if (!candidate || !candidate.snapshot) return false;
    var monday = candidate.snapshot.monday || {};
    var payment = candidate.snapshot.payment || {};
    return monday.state === 'pending' && payment.state === 'pending' &&
      (monday.mode === 'manager_approval_pending' || payment.mode === 'manager_approval_pending');
  }

  function isManagerApprovalPending() {
    return isManagerApprovalPendingState(state);
  }

  function armTerminalTimeout() {
    clearDeadlineTimers();
    if (!state || allTerminal() || isManagerApprovalPending()) return;
    var elapsed = Date.now() - Number(state.startedAt || Date.now());

    function showSlowNotice() {
      slowNoticeTimer = 0;
      if (!state || !state.snapshot || allTerminal() || isManagerApprovalPending()) return;
      hideQuoteLoader();
      render('Confirmation is still processing. Do not submit again; this page will keep checking for the final result.');
    }

    function showLongDelayNotice() {
      terminalTimer = 0;
      if (!state || !state.snapshot || allTerminal() || isManagerApprovalPending()) return;
      hideQuoteLoader();
      render('Confirmation is taking longer than expected. Do not submit again. Contact Automations while this page keeps checking.');
    }

    if (elapsed >= TERMINAL_TIMEOUT_MS) {
      showLongDelayNotice();
      return;
    }
    if (elapsed >= SLOW_STATUS_NOTICE_MS) showSlowNotice();
    else slowNoticeTimer = window.setTimeout(showSlowNotice, Math.max(1000, SLOW_STATUS_NOTICE_MS - elapsed));
    terminalTimer = window.setTimeout(showLongDelayNotice, Math.max(1000, TERMINAL_TIMEOUT_MS - elapsed));
  }

  function mergeStatusStage(kind, incoming) {
    if (!state || !state.snapshot || !incoming || typeof incoming !== 'object') return;
    var nextState = String(incoming.state || '').toLowerCase();
    if (kind === 'payment' && nextState === 'pending' && incoming.accepted === true) nextState = 'accepted';
    if (!['pending','success','failed','blocked','unconfirmed'].includes(nextState) && !(kind === 'payment' && nextState === 'accepted')) return;
    var current = state.snapshot[kind] || {};
    var currentState = String(current.state || 'pending').toLowerCase();
    if (nextState === 'pending' && ['success','failed','blocked','accepted'].includes(currentState)) return;
    if (nextState === 'accepted' && ['success','failed','blocked'].includes(currentState)) return;
    state.snapshot[kind] = Object.assign({}, current, incoming, { state: nextState });
  }

  function applyStatusResponse(payload) {
    if (!state || !state.draftId || !payload || payload.ok !== true) return;
    if (String(payload.draftOrderId || '') !== state.draftId) return;
    mergeStatusStage('shopify', payload.shopify);
    mergeStatusStage('monday', payload.monday);
    mergeStatusStage('payment', payload.payment);
    var invoiceUrl = safeUrl(payload.invoiceUrl);
    if (invoiceUrl) state.invoiceUrl = invoiceUrl;
    saveState();
    if (state.snapshot.monday && state.snapshot.monday.state !== 'pending') hideQuoteLoader();
    render();
    if (allTerminal()) {
      clearDeadlineTimers();
      window.clearTimeout(statusPollTimer);
      statusPollTimer = 0;
      disconnectRealtime();
    } else {
      armTerminalTimeout();
    }
  }

  function scheduleStatusPoll(delay) {
    window.clearTimeout(statusPollTimer);
    statusPollTimer = 0;
    if (!state || !state.draftId || state.draftId === 'failed' || allTerminal() || isManagerApprovalPending()) return;
    statusPollTimer = window.setTimeout(pollQuoteStatus, Math.max(1000, Number(delay) || STATUS_POLL_INTERVAL_MS));
  }

  async function pollQuoteStatus() {
    statusPollTimer = 0;
    if (!state || !state.draftId || state.draftId === 'failed' || allTerminal() || isManagerApprovalPending()) return;
    if (statusPollInFlight) {
      scheduleStatusPoll(STATUS_POLL_INTERVAL_MS);
      return;
    }
    if (!window.CAP_SR1 || typeof window.CAP_SR1.quoteWorkflowFetch !== 'function') {
      scheduleStatusPoll(STATUS_POLL_INTERVAL_MS);
      return;
    }
    statusPollInFlight = true;
    var nextDelay = STATUS_POLL_INTERVAL_MS;
    try {
      var response = await window.CAP_SR1.quoteWorkflowFetch('status', { draft_order_id: state.draftId });
      var payload = {};
      try { payload = await response.clone().json(); } catch (error) {}
      if (response.ok && payload.ok === true) applyStatusResponse(payload);
      var requestedDelay = Number(payload.pollAfterMs || 0);
      if (Number.isFinite(requestedDelay) && requestedDelay > 0) {
        nextDelay = Math.max(5000, Math.min(15000, requestedDelay));
      }
    } catch (error) {
      // Realtime remains the primary fast path; the next protected poll retries reconciliation.
    } finally {
      statusPollInFlight = false;
      if (state && !allTerminal() && !isManagerApprovalPending()) scheduleStatusPoll(nextDelay);
    }
  }

  function applyBroadcast(message) {
    if (!state || !isToken(state.token)) return;
    var payload = message && message.payload ? message.payload : message || {};
    if (String(payload.status_token || '').toLowerCase() !== state.token) return;
    var stage = String(payload.stage || '').toLowerCase();
    if (!['shopify','monday','payment'].includes(stage)) return;
    var nextState = String(payload.state || '').toLowerCase();
    if (stage === 'payment' && nextState === 'pending' && payload.accepted === true) nextState = 'accepted';
    if (!['pending','success','failed','blocked','unconfirmed'].includes(nextState) && !(stage === 'payment' && nextState === 'accepted')) return;
    state.snapshot = state.snapshot || {};
    state.snapshot[stage] = state.snapshot[stage] || {};
    mergeStatusStage(stage, {state:nextState});
    nextState = state.snapshot[stage].state;
    if (stage === 'payment') {
      ['accepted','delivered','delivery_state','delivery_status','readback_state'].forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) state.snapshot.payment[key] = payload[key];
      });
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'mode')) state.snapshot[stage].mode = String(payload.mode || '');
    if (payload.automation_reference) state.automationReference = String(payload.automation_reference).trim();
    if (payload.automation_execution_id || payload.automationExecutionId) {
      state.automationExecutionId = String(payload.automation_execution_id || payload.automationExecutionId).trim();
    }
    if (stage === 'monday') {
      var mondayUrl = safeMondayUrl(payload.monday_url || payload.mondayUrl);
      var mondayItemCount = Number(payload.monday_item_count || payload.mondayItemCount || 0);
      if (mondayUrl) state.mondayUrl = mondayUrl;
      if (Number.isInteger(mondayItemCount) && mondayItemCount > 0) state.mondayItemCount = mondayItemCount;
      if (nextState === 'pending') {
        state.retryAvailable = false;
        state.diagnostics = [];
        if (state.snapshot.monday.mode === 'manager_approval_pending') {
          state.retryRunning = false;
          hideQuoteLoader();
        } else {
          state.retryRunning = true;
          showQuoteLoader();
        }
      } else {
        state.retryRunning = false;
        retryInFlight = false;
      }
      if (payload.retry_available === true) state.retryAvailable = true;
      if (Array.isArray(payload.diagnostics)) state.diagnostics = payload.diagnostics.slice(0, 20);
      if (nextState === 'success') {
        state.retryAvailable = false;
        state.diagnostics = [];
      }
    }
    if (stage === 'payment') {
      var podiumUrl = safePodiumUrl(payload.podium_url || payload.podiumUrl);
      if (podiumUrl) state.podiumUrl = podiumUrl;
    }
    if (!isManagerApprovalPending()) managerCheckInFlight = false;
    if (isManagerApprovalPending()) hideQuoteLoader();
    saveState();
    if (stage === 'monday' && nextState !== 'pending') hideQuoteLoader();
    render();
    if (allTerminal()) {
      clearDeadlineTimers();
      window.clearTimeout(statusPollTimer);
      statusPollTimer = 0;
      disconnectRealtime();
    } else {
      armTerminalTimeout();
      scheduleStatusPoll(STATUS_POLL_INTERVAL_MS);
    }
  }

  function connectRealtime(token) {
    token = String(token || '').trim().toLowerCase();
    if (!isToken(token)) return;
    disconnectRealtime();
    var config = window.__CAP_SR1_CONFIG__ || {};
    if (!window.supabase || typeof window.supabase.createClient !== 'function' ||
        !config.quoteStatusSupabaseUrl || !config.quoteStatusPublishableKey) {
      if (state && state.draftId) render('Real-time status connection is unavailable. Contact Automations.');
      return;
    }
    realtimeClient = window.supabase.createClient(
      config.quoteStatusSupabaseUrl,
      config.quoteStatusPublishableKey,
      { auth: { persistSession:false, autoRefreshToken:false, detectSessionInUrl:false } }
    );
    realtimeChannel = realtimeClient
      .channel('quote-status:' + token, { config: { broadcast: { self:false } } })
      .on('broadcast', { event:'status' }, applyBroadcast)
      .subscribe(function (channelStatus) {
        if (channelStatus === 'CHANNEL_ERROR' && state && state.draftId) {
          render('Real-time status connection failed. Contact Automations if the pending stages do not update.');
        }
      });
    armTerminalTimeout();
  }

  function beginStatusToken(token) {
    token = String(token || '').trim().toLowerCase();
    if (!isToken(token)) return;
    managerCheckInFlight = false;
    showQuoteLoader();
    state = {
      token: token,
      draftId: '',
      draftNumber: '',
      adminUrl: '',
      invoiceUrl: '',
      mondayUrl: '',
      mondayItemCount: 0,
      podiumUrl: '',
      automationReference: '',
      automationExecutionId: '',
      retryAvailable: false,
      retryRunning: false,
      diagnostics: [],
      startedAt: Date.now(),
      snapshot: { shopify:{state:'pending'}, monday:{state:'pending'}, payment:{state:'pending',mode:''} }
    };
    try { window.sessionStorage.setItem(TOKEN_KEY, token); } catch (error) {}
    saveState();
    connectRealtime(token);
  }

  function draftIdFromAdminUrl(url) {
    var match = String(url || '').match(/\/draft_orders\/(\d+)/i);
    return match ? 'gid://shopify/DraftOrder/' + match[1] : '';
  }

  function captureSuccess() {
    var numberEl = statusEl.querySelector('.rep-tools__draft-number');
    var adminLink = statusEl.querySelector('a[href*="/draft_orders/"]');
    var paymentLink = statusEl.querySelector('a.rep-tools__status-link--secondary');
    var adminUrl = adminLink ? safeUrl(adminLink.href) : '';
    var draftId = draftIdFromAdminUrl(adminUrl);
    if (!draftId) return;

    var token = state && isToken(state.token) ? state.token : '';
    if (!token) {
      try { token = String(window.sessionStorage.getItem(TOKEN_KEY) || '').trim().toLowerCase(); } catch (error) {}
    }
    var priorSnapshot = state && state.snapshot ? state.snapshot : null;
    state = {
      token: token,
      draftId: draftId,
      draftNumber: String(numberEl ? numberEl.textContent : '').trim(),
      adminUrl: adminUrl,
      invoiceUrl: paymentLink ? safeUrl(paymentLink.href) : '',
      mondayUrl: state && safeMondayUrl(state.mondayUrl) || '',
      mondayItemCount: state && Number(state.mondayItemCount) || 0,
      podiumUrl: state && safePodiumUrl(state.podiumUrl) || '',
      automationReference: state && String(state.automationReference || '') || '',
      automationExecutionId: state && String(state.automationExecutionId || '') || '',
      retryAvailable: state && state.retryAvailable === true,
      retryRunning: state && state.retryRunning === true,
      diagnostics: state && Array.isArray(state.diagnostics) ? state.diagnostics : [],
      startedAt: state && state.startedAt ? state.startedAt : Date.now(),
      snapshot: priorSnapshot || { shopify:{state:'success'}, monday:{state:'pending'}, payment:{state:'pending',mode:''} }
    };
    state.snapshot.shopify = {state:'success'};
    saveState();
    render();
    if (isToken(token) && !realtimeChannel && !allTerminal()) connectRealtime(token);
    else armTerminalTimeout();
    scheduleStatusPoll(1000);
  }

  function captureFailure() {
    managerCheckInFlight = false;
    hideQuoteLoader();
    stopStatusTracking();
    var detail = String(statusEl.textContent || '').trim();
    state = {
      token: state && state.token || '',
      draftId: 'failed',
      draftNumber: '',
      adminUrl: '',
      invoiceUrl: '',
      automationReference: '',
      automationExecutionId: '',
      retryAvailable: false,
      retryRunning: false,
      diagnostics: [],
      startedAt: Date.now(),
      snapshot: { shopify:{state:'failed'}, monday:{state:'blocked'}, payment:{state:'blocked',mode:''} }
    };
    saveState();
    rendering = true;
    statusEl.classList.add('cap-quote-stage-status-shell');
    statusEl.innerHTML = '<div class="cap-stage-alert">' + escapeHtml(detail || 'Shopify did not confirm the Draft Order.') + '</div>' +
      '<div class="cap-quote-stage-grid" role="status" aria-live="polite">' +
      cardHtml('shopify', 'Shopify', 'failed', '') +
      cardHtml('monday', 'Monday.com', 'blocked', '') +
      cardHtml('payment', 'Podium', 'blocked', '') +
      '</div>';
    window.setTimeout(function () { rendering = false; }, 0);
  }

  function createRetryRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.from(bytes).map(function (value) { return value.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0,8) + '-' + hex.slice(8,12) + '-' + hex.slice(12,16) + '-' + hex.slice(16,20) + '-' + hex.slice(20);
  }

  async function retryQuoteVerification(button) {
    if (retryInFlight || !state || !state.retryAvailable || !state.draftId || !isToken(state.token) || !state.automationReference) return;
    if (!window.CAP_SR1 || typeof window.CAP_SR1.quoteWorkflowFetch !== 'function') {
      render('Secure retry is unavailable. Contact Automations.');
      return;
    }
    retryInFlight = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      button.textContent = 'Starting retry…';
    }
    var priorMonday = state.snapshot.monday.state;
    var priorPayment = state.snapshot.payment.state;
    var priorDiagnostics = Array.isArray(state.diagnostics) ? state.diagnostics.slice() : [];
    state.retryAvailable = false;
    state.retryRunning = true;
    state.diagnostics = [];
    state.snapshot.monday.state = 'pending';
    state.snapshot.payment.state = 'pending';
    state.startedAt = Date.now();
    saveState();
    showQuoteLoader();
    render();
    connectRealtime(state.token);
    try {
      var response = await window.CAP_SR1.quoteWorkflowFetch('retry', {
        draft_order_id: state.draftId,
        quote_status_token: state.token,
        automation_reference: state.automationReference,
        request_id: createRetryRequestId()
      });
      var payload = {};
      try { payload = await response.clone().json(); } catch (error) {}
      if (!response.ok) throw new Error(String(payload.message || payload.code || 'Retry request failed.'));
      armTerminalTimeout();
    } catch (error) {
      retryInFlight = false;
      state.retryAvailable = true;
      state.retryRunning = false;
      state.snapshot.monday.state = priorMonday;
      state.snapshot.payment.state = priorPayment;
      state.diagnostics = priorDiagnostics;
      saveState();
      hideQuoteLoader();
      render(String(error && error.message || error || 'Retry could not be started.'));
    }
  }

  async function checkManagerApproval(button) {
    if (managerCheckInFlight || !state || !isManagerApprovalPending()) return;
    if (!state.draftId || !isToken(state.token) || !state.automationReference) {
      render('Manager approval reference is unavailable. Contact Automations.');
      return;
    }
    if (!window.CAP_SR1 || typeof window.CAP_SR1.quoteWorkflowFetch !== 'function') {
      render('Secure manager approval check is unavailable. Contact Automations.');
      return;
    }
    managerCheckInFlight = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      button.textContent = 'Checking Manager Approval…';
    }
    render();
    try {
      var response = await window.CAP_SR1.quoteWorkflowFetch('retry', {
        manager_approval_check: true,
        draft_order_id: state.draftId,
        quote_status_token: state.token,
        automation_reference: state.automationReference,
        request_id: createRetryRequestId()
      });
      var payload = {};
      try { payload = await response.clone().json(); } catch (error) {}
      if (!response.ok) throw new Error(String(payload.message || payload.code || 'Manager approval check failed.'));
      managerCheckInFlight = false;
      if (isManagerApprovalPending()) render();
    } catch (error) {
      managerCheckInFlight = false;
      render(String(error && error.message || error || 'Manager approval could not be checked.'));
    }
  }

  function inspectStatus() {
    if (rendering || !statusEl || statusEl.querySelector('.cap-quote-stage-grid')) return;
    if (lastAction !== 'create') return;
    if (statusEl.classList.contains('rep-tools__status--success')) captureSuccess();
    else if (statusEl.classList.contains('rep-tools__status--error')) captureFailure();
  }

  function bind() {
    statusEl = document.getElementById('rep-tools-status');
    if (!statusEl) return;

    window.addEventListener('cap:quote-status-token', function (event) {
      beginStatusToken(event && event.detail ? event.detail.token : '');
    });

    document.addEventListener('click', function (event) {
      var retry = event.target.closest('[data-cap-retry-quote]');
      var managerCheck = event.target.closest('[data-cap-check-manager-approval]');
      var create = event.target.closest('#rep-create-draft');
      var update = event.target.closest('#rep-update-draft');
      var clear = event.target.closest('#rep-clear-fields, #rep-clear-cart, #rep-clear-cart-fields');
      if (managerCheck) {
        event.preventDefault();
        checkManagerApproval(managerCheck);
      } else if (retry) {
        event.preventDefault();
        retryQuoteVerification(retry);
      } else if (create) {
        clearState();
        lastAction = 'create';
      } else if (update) {
        lastAction = 'update';
      } else if (clear) {
        clearState();
        lastAction = '';
      }
    }, true);

    observer = new MutationObserver(inspectStatus);
    observer.observe(statusEl, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});

    var saved = loadState();
    if (saved) {
      state = saved;
      lastAction = 'create';
      retryInFlight = state.retryRunning === true;
      managerCheckInFlight = false;
      if (state.draftId && state.draftId !== 'failed') render();
      if (state.snapshot && state.snapshot.monday && state.snapshot.monday.state === 'pending' && !isManagerApprovalPending()) showQuoteLoader();
      else hideQuoteLoader();
      if (!allTerminal()) connectRealtime(state.token);
      scheduleStatusPoll(1000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
})();

